import { render, staticRenderFns } from "./AuthorisePartOld.vue?vue&type=template&id=4484b940"
import script from "./AuthorisePartOld.vue?vue&type=script&lang=js"
export * from "./AuthorisePartOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4484b940')) {
      api.createRecord('4484b940', component.options)
    } else {
      api.reload('4484b940', component.options)
    }
    module.hot.accept("./AuthorisePartOld.vue?vue&type=template&id=4484b940", function () {
      api.rerender('4484b940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthorisePartOld.vue"
export default component.exports